import React from 'react'
import RaisedButton from 'material-ui-legacy/RaisedButton'
import NavigationClose from 'material-ui-legacy/svg-icons/navigation/close'

const CancelButton = (props) => (
  <RaisedButton
    style={props.style || {margin: '5px'}}
    onTouchTap={props.onTouchTap}
    label={props.label || "Cancel"}
    labelPosition="after"
    secondary={true}
    icon={props.icon || <NavigationClose/>}
    {...props}
  />
)

export default CancelButton



// WEBPACK FOOTER //
// ./src/components/UI/CancelButton.jsx